import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useResolveToken } from "../hooks/useResolveToken.js";
import { db } from "../lib/firebase.js";
import { addList } from "../lib/storage.js";

interface Props {
  onListsChange: () => void;
}

export function JoinPage({ onListsChange }: Props) {
  const { shareToken } = useParams<{ shareToken: string }>();
  const { listId, loading, error } = useResolveToken(shareToken);
  const [joinError, setJoinError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!listId || !shareToken) return;

    const join = async () => {
      try {
        const listDoc = await getDoc(doc(db, "lists", listId));
        const name = listDoc.exists() ? (listDoc.data().name as string) : "";

        addList({ listId, shareToken, name });
        onListsChange();
        navigate("/", { replace: true });
      } catch (err) {
        console.error("Failed to join list:", err);
        setJoinError("リストへの参加に失敗しました。もう一度お試しください。");
      }
    };

    join();
  }, [listId, shareToken, navigate, onListsChange]);

  if (loading) {
    return (
      <main
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100dvh",
        }}
      >
        <output>リストに参加中…</output>
      </main>
    );
  }

  if (error || joinError) {
    return (
      <main
        role="alert"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100dvh",
          gap: "1rem",
        }}
      >
        <p style={{ color: "#ef4444" }}>{error ?? joinError}</p>
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            padding: "0.5rem 1rem",
            borderRadius: "6px",
            border: "1px solid #ddd",
            cursor: "pointer",
          }}
        >
          ホームへ
        </button>
      </main>
    );
  }

  return null;
}
